import Header from "./Header";
import Footer from "./Footer";
import SideBar from "./SideBar";

// import "./layout.css";

export default function Layout({children}){
    return <>
        {/* <!-- ======= Header ======= --> */}
        <Header></Header>
        {/* <!-- ======= Sidebar ======= --> */}
        <SideBar></SideBar>
        {children}
        {/* <!-- ======= Footer ======= --> */}
        <Footer></Footer>
    
    </>;

}